import { render, staticRenderFns } from "./WidgetActions.vue?vue&type=template&id=b34617fe&"
import script from "./WidgetActions.vue?vue&type=script&lang=js&"
export * from "./WidgetActions.vue?vue&type=script&lang=js&"
import style0 from "./WidgetActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports